import _ from 'lodash'

export const _matchAccessLevels = {
  team: 'team',
  sport: 'sport',
  school: 'school',
  admin: 'admin'
}

export const _matchResultTypes = {
  normal: 'normal',
  realtime: 'realtime',
  matchDay: 'matchDay'
}

const rts = {
  handleSet_latestSeason: 'handleSet_latestSeason',
  handleSet_matchAllowances: 'handleSet_matchAllowances',
  handleSet_matchDataUpdates: 'handleSet_matchDataUpdates',
  handleSet_matchDayMatchData: 'handleSet_matchDayMatchData',
  handleSet_realtimeMatchData: 'handleSet_realtimeMatchData',
  handleSet_rtMatch: 'handleSet_rtMatch',
  handleSet_trueMatch: 'handleSet_trueMatch',
  handleShow_matchScoreTable: 'handleShow_matchScoreTable',
  handleShow_scoreEdit: 'handleShow_scoreEdit',
  handleShow_scoreEdit: 'handleShow_scoreEdit',
}

export const matchDisplayTypes = {
  matchOptions: 'matchOptions',
  realtimeScoring: 'realtimeScoring',
}

export const sportsMatchReducer = (state, action) => {

  const { type } = action

  switch (type) {

    case rts.handleShow_scoreEdit:
      return { ...state, match_edit: _.cloneDeep(action.match), showMatchScoreTable: false, editFromRt: action.editFromRt }

    case rts.handleSet_latestSeason:
      return { ...state, latestSeason: action.latestSeason }

    case rts.handleSet_rtMatch:
      const { match_rt } = action
      if (match_rt && !match_rt?._results?.setNumber) { match_rt._results.setNumber = 1 }
      return { ...state, match_rt: action.match_rt }

    case rts.handleSet_realtimeMatchData:
      return { ...state, matchData_rt: action.matchData_rt }

    case rts.handleSet_matchDayMatchData:
      return { ...state, matchDayMatchData: action.matchDayMatchData }

    case rts.handleSet_matchAllowances:
      const { matchAllows } = action ?? {}
      const { full, scores, scores_p, edit, matchAccessLevel } = matchAllows ?? {}
      const _matchAllows = {
        full: full ? true : false,
        edit: full || edit ? true : false,
        scores_p: scores_p ? true : false,
        scores: full || edit || scores ? true : false,
        matchAccessLevel
      }
      return { ...state, matchAllows: _matchAllows }

    case rts.handleSet_matchDataUpdates:
      const _mpdu = _.cloneDeep(action.matchDataUpdates)
      Object.keys(_mpdu).forEach(k => {
        delete _mpdu[k].
          _existingInfo

      })
      return { ...state, matchDataUpdates: _mpdu }

    case rts.handleSet_trueMatch:
      return { ...state, match_true: action.match_true }

    case rts.handleShow_matchScoreTable:
      return { ...state, scoresOn: false, showMatchScoreTable: !state.showMatchScoreTable }

    default:
      return { ...state }
  }
}

export const sportsMatchHandlers = (dispatch) => {
  return {
    handleSet_latestSeason: (latestSeason) => { dispatch({ type: rts.handleSet_latestSeason, latestSeason }) },
    handleSet_matchAllowances: (matchAllows) => { dispatch({ type: rts.handleSet_matchAllowances, matchAllows }) },
    handleSet_matchDataUpdates: (matchDataUpdates) => { dispatch({ type: rts.handleSet_matchDataUpdates, matchDataUpdates }) },
    handleSet_rtMatch: (match_rt) => { dispatch({ type: rts.handleSet_rtMatch, match_rt }) },
    handleSet_matchDayMatchData: (matchDayMatchData) => { dispatch({ type: rts.handleSet_matchDayMatchData, matchDayMatchData }) },
    handleSet_realtimeMatchData: (matchData_rt) => { dispatch({ type: rts.handleSet_realtimeMatchData, matchData_rt }) },
    handleSet_trueMatch: (match_true, match_dy) => { dispatch({ type: rts.handleSet_trueMatch, dispatch, match_true, match_dy }) },
    handleShow_matchScoreTable: (match) => { dispatch({ type: rts.handleShow_matchScoreTable, match }) },
    handleShow_scoreEdit: (match, editFromRt) => { dispatch({ type: rts.handleShow_scoreEdit, match, editFromRt }) },
  }
}

export const sportsMatchInitialState = (init_state) => {
  return { ...init_state, currentAthletes: {}, matchAllows: { scores: false, edit: false, full: false } }
};

export const ammendTeamName = (name) => {
  const _name = name ? name.trim() : name

  switch (_name) {

    case 'Apollo-Ridge':
      return 'Apollo Ridge'

    case 'Beaver Area':
      return 'Beaver'

    case 'Beaver C.C.':
      return 'Beaver County Christian'

    case 'Bethleham-Center':
    case 'Bethlehem-Center':
      return 'Beth Center'

    case 'Calvary Chapel':
      return 'Calvary Chapel'

    case 'Canon-McMillian':
    case 'Canon-McMillan':
    case 'Canon Mcmillian':
    case 'Canon Mac':
      return 'Canon McMillan'

    case 'Central Cath':
      return 'Central Catholic'

    case 'Char Houston':
      return 'Chartiers Houston'

    case 'Chartiers Vall':
      return 'Chartiers Valley'

    case 'Derry':
      return 'Derry Area'

    case 'Eden Christian Academy':
    case 'Eden Christian Acad.':
      return 'Eden Christian'

    case 'Elizabeth Fwd':
      return 'Elizabeth Forward'

    case 'Fort Cheery':
      return 'Fort Cherry'

    case 'Freedom Area':
      return 'Freedom'

    case 'Franklin Reg':
      return 'Franklin Regional'

    case 'Geibel Catholic':
      return 'Geibel'

    case 'Gbg Salem':
      return 'Greensburg Salem'

    case 'Greater Latrobe':
      return 'Latrobe'

    case 'Greensburg CC':
    case 'Greensburg C.C.':
    case 'Gbg Central Cth':
    case 'Greensburgh Central Cth':
      return 'Greensburg Central Catholic'

    case 'Hempfield Area':
      return 'Hempfield'

    case 'Hillcrest Academy':
      return 'Hillcrest Christian Academy'

    case 'Imani Christian Acad':
    case 'Imani Christian Acad.':
    case 'Imani Christian Academy':
      return 'Imani Christian'

    case 'Jefferson-Morgan':
    case 'Jeff Morgan':
      return 'Jefferson Morgan'

    case 'Keyston Oaks':
      return 'Keystone Oaks'

    case 'Kiski':
      return 'Kiski Area'

    case 'Laurel High':
      return 'Laurel Highlands'

    case 'Mcguffy':
      return 'McGuffey'

    case 'Mckeesport':
      return 'McKeesport'

    case 'Mount Pleasant':
      return 'Mt. Pleasant'

    case 'Neighborhood A.':
    case 'The Neighborhood Acad':
    case 'The Neighborhood Academy':
      return 'Neighborhood Academy'

    case 'North Allegh':
      return 'North Allegheny'

    case 'OLSH':
    case 'Olsh':
    case 'Our Lady of the Sacred Heart':
    case 'O.L. Sacred Heart':
    case 'Our Lady of Sacred Heart':
      return 'O.L.S.H.'

    case 'Penn-Trafford':
      return 'Penn Trafford'

    case 'Peters':
    case 'Peters Twp':
      return 'Peters Township'

    case 'Pine-Richland':
    case 'Pine-richland':
      return 'Pine Richland'

    case 'Propel':
      return 'Propel Braddock Hills'

    case 'Saint Joseph':
      return 'St. Joseph'

    case 'Seton La Salle':
    case 'Seton-la Salle':
      return 'Seton LaSalle'

    case 'Shady Side Aca':
      return 'Shady Side Academy'

    case 'Shaler':
      return 'Shaler Area'

    case 'South Alleghny':
      return 'South Allegheny'

    case 'South Side Beaver':
    case 'South Side':
      return 'South Side Area'

    case 'Sto Rox':
      return 'Sto-Rox'

    case 'Sto-Rox':
      return _name

    case 'Summit Acadmy':
    case 'The Summit Academy':
      return 'Summit Academy'

    case 'Thomas Jeff':
      return 'Thomas Jefferson'

    case 'Union':
      return 'Union Area'

    case 'Waynesburg Central':
      return 'Waynesburg'

    default:
      return _name ? _name.replace('-', ' ') : _name
  }
}

export const matchNeedsUpdated = (matchResults, results) => {
  if (matchResults && matchResults.score && results.score)
    if (matchResults.score.home !== results.score.home || matchResults.score.away !== results.score.away) {
      return true
    }
}

export const fixTeamNames = (matches) => {
  Object.keys(matches).forEach(mk => {
    const match = matches[mk]
    const { home, away } = match ?? {}
    match.home = ammendTeamName(home)
    match.away = ammendTeamName(away)
  })
}